import {
  QuantityGuideProps,
  BrewServing as BrewServingProps,
} from "@bluebottlecoffee/design-system/components";
import {
  BrewServing,
  QuantityGuide as QuantityGuideSchema,
} from "../sanity-schema";

function toBrewServingProps(
  { brewStyle, dose, quantities }: BrewServing,
  lang: string,
): BrewServingProps {
  return {
    brewStyle: brewStyle[lang],
    dose: dose[lang],
    quantities,
  };
}

export function toQuantityGuideProps(
  {
    heading,
    servingSize,
    tableSummary,
    methodHeading,
    brewServings,
  }: QuantityGuideSchema,
  lang: string,
): QuantityGuideProps {
  return {
    heading: heading[lang],
    servingSize: servingSize[lang],
    tableSummary: tableSummary[lang],
    methodHeading: methodHeading[lang],
    brewServings: brewServings.map((bs) => toBrewServingProps(bs, lang)),
  };
}
